import React, { useState, useEffect } from 'react';
const classNames = require('classnames');

interface TabItemProps {
    active: boolean;
    label: string;
    idx: number;
    onClick: (index: number) => void;
    unread?: number;
}

const TabItem: React.FC<TabItemProps> = ({ active, label, idx, onClick, unread }) => {
    const [unreadCounter, setUnreadCounter] = useState(0);

    const linkClass = classNames({
        tab__item: true,
        tab__active: active,
    });

    const tabId: string = label.replace(/\s/g, '').toLowerCase();

    const formatCounter = num => {
        if (num > 99) {
            return '99+';
        }
        return num;
    };

    useEffect(() => {
        setUnreadCounter(unread);
    }, [unread]);

    return (
        <a className={linkClass} id={tabId} onClick={() => onClick(idx)}>
            {label}
            {tabId === 'inbox' && formatCounter(unreadCounter) ? <span className="tab__counter__active">{formatCounter(unreadCounter)}</span> : null}
        </a>
    );
};

export default TabItem;



// WEBPACK FOOTER //
// ./src/components/Tabs/TabItem.tsx